import useJwt from '@core/auth/jwt/useJwt'
import axiosDevice from '../../libs/axiosDevice'

const { jwt } = useJwt(axiosDevice, {})
export default jwt
